
export const GET_AUDITOR_LIST='GET_AUDITOR_LIST';
export const API_CALL_STATUS = 'API_CALL_STATUS';
export const GET_SELECTED_AUDITOR='GET_SELECTED_AUDITOR';
export const IS_AUDITOR_EDIT = 'IS_AUDITOR_EDIT';
export const IS_AUDITOR_CREATE = 'IS_AUDITOR_CREATE';
export const IS_AUDITOR_LIST = 'IS_AUDITOR_LIST';
export const GET_AUDITOR_CONTRACT_LIST='GET_AUDITOR_CONTRACT_LIST';
export const GET_AUDITOR_SUPPLY_LIST='GET_AUDITOR_SUPPLY_LIST';
export const GET_SELECTED_AUDITOR_FOR_SETTING = 'GET_SELECTED_AUDITOR_FOR_SETTING';
export const GET_ASSET_DETAILS = "GET_ASSET_DETAILS"